export const zeroPad = (num: number, places: number) =>
  String(num).padStart(places, "0");

export const generatePin = () => Math.floor(1000 + Math.random() * 9000);
